import { authService } from '~/services/auth-service';
import type { AuthUser } from '~/types/auth/auth';

export const usePersonStore = defineStore(
    'person',
    () => {
        const person = ref<AuthUser | null>(null);
        const loaded = ref(false);

        async function loadMe() {
            const user = await authService.getMe();
            person.value = user;
            loaded.value = true;
            return user;
        }

        function clear() {
            person.value = null;
            loaded.value = false;
        }

        return { person, loaded, loadMe, clear };
    },
    {
        persist: {
            pick: ['person'],
        },
    }
);

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePersonStore, import.meta.hot));
}
